<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <strong>{{ labels.resources }}</strong>
            <button
                v-if="!disabled"
                type="button"
                class="btn btn-default btn-xs pull-right"
                @click="addResource"
            >
                {{ labels.addResource }}
            </button>
        </div>
        <div class="panel-body">
            <div
                v-for="(resource, index) in resources"
                :key="resource._key"
                class="row resource-row"
            >
                <input v-if="resource.id" type="hidden" :name="`resources[${index}][id]`" :value="resource.id">
                <div class="col-md-3 form-group" :class="{ 'has-error': fieldError(`resources.${index}.key`) }">
                    <label class="control-label">{{ labels.resourceKey }}</label>
                    <input
                        v-model="resource.key"
                        class="form-control"
                        type="text"
                        :name="`resources[${index}][key]`"
                        :disabled="disabled"
                        :readonly="disabled"
                    >
                </div>
                <div class="col-md-2 form-group" :class="{ 'has-error': fieldError(`resources.${index}.type`) }">
                    <label class="control-label">{{ labels.resourceType }}</label>
                    <select
                        v-model="resource.type"
                        class="form-control"
                        :name="`resources[${index}][type]`"
                        :disabled="disabled"
                    >
                        <option v-for="(label, value) in resourceTypes" :key="value" :value="value">{{ label }}</option>
                    </select>
                </div>
                <div class="col-md-2 form-group" :class="{ 'has-error': fieldError(`resources.${index}.sort_order`) }">
                    <label class="control-label">{{ labels.resourceSortOrder }}</label>
                    <input
                        v-model.number="resource.sort_order"
                        class="form-control"
                        type="number"
                        :name="`resources[${index}][sort_order]`"
                        :disabled="disabled"
                        :readonly="disabled"
                    >
                </div>
                <div class="col-md-4 form-group" :class="{ 'has-error': fieldError(`resources.${index}.content`) }">
                    <label class="control-label">{{ labels.resourceContent }}</label>
                    <textarea
                        v-model="resource.content"
                        class="form-control"
                        rows="3"
                        :name="`resources[${index}][content]`"
                        :disabled="disabled"
                        :readonly="disabled"
                    ></textarea>
                </div>
                <div v-if="!disabled" class="col-md-1 form-group">
                    <label class="control-label">&nbsp;</label>
                    <button type="button" class="btn btn-danger btn-block" @click="removeResource(index)">
                        {{ labels.removeResource }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        resourceTypes: {
            type: Object,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        resources: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        addResource() {
            this.resources = [
                ...this.resources,
                {
                    _key: `new-${Date.now()}`,
                    id: null,
                    key: '',
                    type: 'prompt',
                    content: '',
                    sort_order: this.resources.length,
                },
            ];
        },
        removeResource(index) {
            this.resources = this.resources.filter((_, rowIndex) => rowIndex !== index);
        },
        fieldError(field) {
            const messages = this.validationErrors[field];

            return Array.isArray(messages) ? messages[0] : '';
        },
    },
};
</script>
